import * as Yup from 'yup'
import {Email} from 'Validations'

export const Validation = Yup.object({
  email: Email,
})
